import React, { useState, useEffect } from 'react';
import './Leaderboard.css'
import CONSTANTS, { computeBasedness, formatDate } from '../constants';
import { useNavigate } from 'react-router-dom';
import moment from "moment-timezone";


const CountdownTimer = () => {
    const [timeLeft, setTimeLeft] = useState("");
  
    useEffect(() => {
      const targetDate = moment.tz('2023-10-01 23:39:00', 'America/New_York');
      
      const intervalId = setInterval(() => {
        const now = moment();
        const duration = moment.duration(targetDate.diff(now));
        
        if (duration.asMilliseconds() <= 0) {
          clearInterval(intervalId); // Clear interval if the target date is reached
          setTimeLeft("Time's up!");
        } else {
          const days = Math.floor(duration.asDays());
          const hours = duration.hours();
          const minutes = duration.minutes();
          const seconds = duration.seconds();
          setTimeLeft(`${days} day ${hours} hours ${minutes} minutes ${seconds} seconds`);
        }
      }, 1000); // Update every second
      
      return () => clearInterval(intervalId); // Clear interval on component unmount
    }, []);
  
    return <div>Time Left in Competition: {timeLeft}</div>;
  };
  

function Leaderboard( {twitterUser} ) {
    const [scores, setScores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState(
        (twitterUser && twitterUser.screen_name) ? 'personal' : 'sprint_levels'
      );
    const navigate = useNavigate();
    function isDateInRange(date, range) {
        if (range.length !== 2) {
            console.error('Date range must have exactly two dates');
            return false;
        }
        
        const targetDate = new Date(date);
        const startDate = new Date(range[0]);
        const endDate = new Date(range[1]);
    
        return targetDate >= startDate && targetDate <= endDate;
    }
    
    // Function to filter data based on the date range
    function filterScoresByDate(scores, range) {
        return scores.filter(score => isDateInRange(score.date.S, range));
    }
    function filterScoreByLevels(scores, levels) {
        return scores.filter(score => levels.includes(score.levelName.S));
    }
    
    const FILTER_CONFIGS = {
        personal: {
            displayName: "My High Scores",
            sortRecent: false,
            collapseToUser: false,
            onlyTwitter: true,
            queryParams: () => ({
                twitterUserName: twitterUser.screen_name
            }),
            style: {
                backgroundColor: "#FF0000" // Red
            },
            visibility: false
        },
        tinyDinosVMfers: {
            displayName: "🔥 Tiny Dinos vs Mfers 🔥",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: true,
            filterToDateRange: ['2023-09-23T16:00:00Z', '2023-09-25T03:59:00Z'],
            filterToLevels: ["Let's F'ing Rawr", "Mfers Jus Getting Started"],
            queryParams: () => ({
                recent: 'true'
            }),
            style: {
                backgroundColor: "#6F99F8",
                color: "black"
            },
            visibility: false
        },
        recent: {
            displayName: "Recent Plays",
            sortRecent: true,
            collapseToUser: false,
            onlyTwitter: false,
            queryParams: () => ({
                recent: 'true'
            }),
            style: {
                backgroundColor: "#0000FF" // Blue
            },
            visibility: true
        },
        sprint_levels: {
            displayName: "Sprint Levels (2 min)",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: false,
            queryParams: () => ({}),
            style: {
                backgroundColor: "#FF0000" // Red
            },
            visibility: true
        },
        darkPepe: {
            displayName: "Dark Pepe Rising",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: true,
            queryParams: () => ({
                levelName: "Dark Pepe Rising"
            }),
            style: {
                backgroundColor: "#006400",
                color: "white"
            },
            visibility: true
        },
        houseSongs: {
            displayName: "House Songs",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: false,
            queryParams: () => ({
                levelName: "House Songs"
            }),
            style: {
                backgroundColor: "#6F99F8", // Blue
                color: "black"
            },
            visibility: true
        },
        tinyDinos: {
            displayName: "Let's F'ing Rawr",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: false,
            queryParams: () => ({
                levelName: "Let's F'ing Rawr"
            }),
            style: {
                backgroundColor: "#6F99F8", // Blue
                color: "black"
            },
            visibility: true
        },
        mfersJusGettingStarted: {
            displayName: "Mfers Jus Getting Started",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: false,
            queryParams: () => ({
                levelName: "Mfers Jus Getting Started"
            }),
            style: {
                backgroundColor: "#6F99F8", // Blue
                color: "black"
            },
            visibility: true
        },
        nakamigoCrush: {
            displayName: "Pixel Crush",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: false,
            queryParams: () => ({
                levelName: "Nakamigo Crush"
            }),
            style: {
                fontFamily: "Nakamigo, sans-serif",
                backgroundColor: "#6F99F8", // Blue
                color: "#000"
            },
            visibility: true
        },
        mfersForever: {
            displayName: "Mfers Forever (Hour Long Play)",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: false,
            queryParams: () => ({
                levelName: "Mfers Forever (Hour Long Play)"
            }),
            style: {
                backgroundColor: "#6F99F8", // Blue
                color: "black"
            },
            visibility: true
        },
        lilMfersPlayground: {
            displayName: "Lil Mfers Playground",
            sortRecent: false,
            collapseToUser: true,
            onlyTwitter: false,
            queryParams: () => ({
                levelName: "Lil Mfers Playground"
            }),
            style: {
                backgroundColor: "#6F99F8", // Blue
                color: "black"
            },
            visibility: true
        }
    };

    function computeTotalScoresByLevel(level, scores) {
        let totalScore = 0;
    
        for (let score of scores) {
            if (score.levelName && score.levelName.S === level) {
                totalScore += parseInt(score.score.N, 10);
            }
        }
        return totalScore;
    }
    
    
    async function fetchData() {
            
        const currentConfig = FILTER_CONFIGS[filter];  // Assuming you have set the currentFilter using the setFilter method
        console.log(currentConfig);
        let url = CONSTANTS.BACKEND_URL;
        const params = currentConfig.queryParams();
        const queryString = new URLSearchParams(params).toString();

        if (queryString) {
            url += '?' + queryString;
        }
        
        try {
            console.log("making request to url");
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            const unwantedNames = ["nngmi_test", "nngmi_test_2", "nngmi_tes", "nngmi_test_all_"];
            let validScores = data.filter(score => {
                if (score.name) {
                    const nameLower = score.name.S.toLowerCase();
                    return !unwantedNames.some(unwanted => nameLower === unwanted.toLowerCase());    
                }
                return true;
            });

            function getHighestScoresByProperty(scores, property) {
                const grouped = {};
            
                scores.forEach(score => {
                    // Ensure the property and its .S value exist
                    if (score[property] && score[property].S) {     
                        const key = score[property].S.toLowerCase().trim();
                        if (!grouped[key] || parseInt(grouped[key].score.N) < parseInt(score.score.N)) {
                            grouped[key] = score;
                        }
                    }
                });
            
                return Object.values(grouped);
            }


            let displayedScores = [...validScores];
            if (currentConfig.filterToDateRange && currentConfig.filterToDateRange.length === 2) {
                displayedScores = filterScoresByDate(displayedScores, currentConfig.filterToDateRange);
            }
            if (currentConfig.filterToLevels) {
                displayedScores = filterScoreByLevels(displayedScores, currentConfig.filterToLevels);
            }
            
            // If there's a need to collapse scores to a single user:
            if (currentConfig.collapseToUser) {
                const originalLength = displayedScores.length;
                const groupedScores = getHighestScoresByProperty(displayedScores, 'name');
                const groupedTwitterScores = getHighestScoresByProperty(displayedScores, 'twitterUserName');
                if (currentConfig.onlyTwitter) {
                    displayedScores = [ ...groupedTwitterScores];
                } else {
                    displayedScores = [...groupedScores, ...groupedTwitterScores];
                }
                console.log("Collapsed ", originalLength, " scores into ", displayedScores.length, "scores");
            }
            
            // Sort logic (e.g. for recent):
            if (currentConfig.sortRecent) {
                displayedScores.sort((a, b) => new Date(b.date.S) - new Date(a.date.S));
            } else {
                displayedScores.sort((a, b) => parseInt(b.score.N) - parseInt(a.score.N));
            }

            console.log("got back ", displayedScores.length, " scores");
            setScores(displayedScores);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching scores:", error);
            setError(error);
            setLoading(false);
        }
    }
    
    
    useEffect(() => {


        fetchData();

    }, [filter]);
    


    if (loading) return <div>Loading...</div>;
    if (error) return <div>Sorry - could not load Leaderboard!</div>;

    return (
        <div>
            <div className="leaderboard-container">
                <table>
                    <thead>
                        <tr>
                            <th colSpan="5">
                                <h1 className="leaderboard-title">
                                    {filter === "recent" ? "Recent Plays" : `Leaderboard - ${FILTER_CONFIGS[filter].displayName}`}
                                </h1>
                                <p>{FILTER_CONFIGS[filter].collapseToUser === true ? "Only highest score per user shown" : ""}</p>
                                <div className="level-buttons">
                                    <button onClick={() => navigate('/')} className="nav-button" style={{ backgroundColor: 'darkred' }}>Home</button>
                                    {Object.keys(FILTER_CONFIGS).map(filterKey => {
                                        const currentConfig = FILTER_CONFIGS[filterKey];
                                        const currentStyle = currentConfig.style;
                                        
                                        // Check for visibility
                                        if (currentConfig.visibility) {
                                            return (
                                                <button 
                                                    key={filterKey}
                                                    style={currentStyle}
                                                    onClick={() => setFilter(filterKey)} 
                                                    className="level-button agg-button"
                                                >
                                                    {currentConfig.displayName}
                                                </button>
                                            );
                                        }
                                        return null; // Return null if the button should not be rendered
                                    })}
                                </div>


                            </th>
                        </tr>
                        <tr>
                            <th>Basedness Level</th>
                            <th>Name</th>
                            <th>Score</th>
                            <th>Level</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
        {scores.map(score => {
            const [label, imageUrl] = computeBasedness(score.score.N, score.levelName.S);
            const levelNameStyle = {
                fontSize: score.levelName.S === 'Nakamigo Crush' ? '0.75em' : '0.9em',
                fontFamily: score.levelName.S === 'Nakamigo Crush' ? 'nakamigo, sans-serif' : 'Sartoshi, sans-serif'
            };
            return (
                <tr style={levelNameStyle} key={score.gameplay.S}>
                    <td>
                        <img src={imageUrl} alt={label} width="50" />
                    </td>
                    <td>
                        {score.twitterUserName ? (
                            <>
                                <a 
                                    href={`/mfersbeheaded/#/player?twitterUserName=${encodeURIComponent(score.twitterUserName.S)}`} 
                                    style={{ color: '#000' }} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    {score.twitterUserName.S}
                                </a>
                            </>
                        ) : (
                            score.name ? score.name.S : 'anon'
                        )}
                    </td>
                    <td data-tooltip="true">{score.score.N}</td>
                    <td style={{ levelNameStyle }}>
                        {score.levelName.S === "Nakamigo Crush" ? "Pixel Crush" : score.levelName.S}
                    </td>
                    <td>{formatDate(score.date.S)}</td>
                </tr>
            );
        })}
    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Leaderboard;
